import React from 'react';
import { FormattedMessage as IntlFormattedMessage } from 'react-intl';
import en from '../../locale/en.json';
var FormattedMessage = function (_a) {
    var id = _a.id, values = _a.values, description = _a.description;
    return (React.createElement(IntlFormattedMessage, { id: id, defaultMessage: en[id], values: values, description: description }));
};
export default FormattedMessage;
